import React, {useMemo, Suspense} from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {createMuiTheme} from '@material-ui/core/styles'
import ThemeProvider from '@material-ui/styles/ThemeProvider'
import {MuiPickersUtilsProvider} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import format from 'date-fns/format'
import koLocale from 'date-fns/locale/ko'
import red from '@material-ui/core/colors/red'
import LoadingLayout from './components/LoadingLayout'
import UserContext from './UserContext'
import useFetch from './libs/useFetch'
import {MenuProvider} from './libs/useMenus'
import { pdfjs } from 'react-pdf';
const publicUrl = process.env.PUBLIC_URL || '';
pdfjs.GlobalWorkerOptions.workerSrc = `${publicUrl}/pdf.worker.min.js`;

const IndexPage = React.lazy(() => import('./pages/IndexPage'))
const MenuPage = React.lazy(() => import('./pages/MenuPage'))
const ScheduleListPage = React.lazy(() => import('./pages/ScheduleListPage'))
const WorkTimeListPage = React.lazy(() => import('./pages/WorkTimeListPage'))
const TeamApprListPage = React.lazy(() => import('./pages/TeamApprListPage'))
const ScheduleWritePage = React.lazy(() => import('./pages/ScheduleWritePage'))
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'))
const VacationListPage = React.lazy(() => import('./pages/VacationListPage'))
const VacationRequestListPage = React.lazy(() => import('./pages/VacationRequestListPage'))
const VacationWritePage = React.lazy(() => import('./pages/VacationWritePage'))
const OtRequestListPage = React.lazy(() => import('./pages/OTRequestListPage'))
const AttSelectiveWorkEntryPage = React.lazy(() => import('./pages/AttSelectiveWorkEntryPage'))
const AttMonthSelectiveWorkEntryPage = React.lazy(() => import('./pages/AttMonthSelectiveWorkEntryPage'))
const AttSelectiveOvertimeRequest = React.lazy(() => import('./pages/AttSelectiveOvertimeRequestEntryPage'))
const AttOvertimeRequestEntryPage = React.lazy(() => import('./pages/AttOvertimeRequestEntryPage'))
const IndvPayDeductQryPage = React.lazy(() => import('./pages/IndvPayDeductQryPage'))
const InstallPaymentApplication = React.lazy(() => import('./pages/InstallPaymentApplication'))
const AttendanceSelfEntry = React.lazy(() => import('./pages/AttendanceSelfEntry'))
const TeamMemberTimeQry = React.lazy(() => import('./pages/TeamMemberTimeQry'))
const IndividualScheduleEntity = React.lazy(() => import('./pages/IndividualScheduleEntity'))
const EmployeeAttSettingQry = React.lazy(() => import('./pages/EmployeeAttSettingQry'))
const TeamMemberAttSettingQry = React.lazy(() => import('./pages/TeamMemberAttSettingQry'))
const SumAttendanceSelfEntry = React.lazy(() => import('./pages/SumAttendanceSelfEntry'))
const AttendanceSelfApply = React.lazy(() => import('./pages/AttendanceSelfApply'))
const SumAttendanceTeamEntry = React.lazy(() => import('./pages/SumAttendanceTeamEntry'))
const ApprovalDocumentQry = React.lazy(() => import('./pages/ApprovalDocumentQry'))
const VacationAdminListPage = React.lazy(() => import('./pages/VacationAdminListPage'))
const YearendEvidQry = React.lazy(() => import('./pages/YearendEvidQry'))
const YearendFinalQry = React.lazy(() => import('./pages/YearendFinalQry'))
const YearendSettleResultQry = React.lazy(() => import('./pages/YearendSettleResultQry'))
const YearendEvidMgt = React.lazy(() => import('./pages/YearendEvidMgt'))
const YearendNonStatusPage = React.lazy(() => import('./pages/YearendNoneStatusPage'))
const AttSelectiveVacationMgt = React.lazy(() => import('./pages/AttSelectiveVacationMgt'))
const AttSelectiveVacationQry = React.lazy(() => import('./pages/AttSelectiveVacationQry'))

function YearendRoutes() {
  return (
    <Switch>
      <Route path="/yearend/evid-qry" component={YearendEvidQry} />
      <Route path='/yearend/final' component={YearendFinalQry} />
      <Route path='/yearend/settle-result' component={YearendSettleResultQry} />
      <Route path='/yearend/evid-mgt' component={YearendEvidMgt} />
      <Route path='/yearend/none-status' component={YearendNonStatusPage} />
    </Switch>
  )
}

function WorkTimeRoutes() {
  return (
    <Switch>
      <Route path="/worktime/schedule" component={ScheduleListPage} />
      <Route path="/worktime/worktime" component={WorkTimeListPage} />
      <Route path="/worktime/write" component={ScheduleWritePage} />
      <Route path="/worktime/approve" component={TeamApprListPage} />
      <Route path="/worktime/ot-request/list" component={OtRequestListPage} />
      <Route path="/worktime/selective/work-entry" component={AttSelectiveWorkEntryPage} />
      <Route path="/worktime/selective/month-work-entry" component={AttMonthSelectiveWorkEntryPage} />
      <Route path="/worktime/attend/att-overtime-request" component={AttOvertimeRequestEntryPage} />
      <Route path="/worktime/attend/att-selective-overtime-request" component={AttSelectiveOvertimeRequest} />
      <Route path="/worktime/attend/attendance-self-entry" component={AttendanceSelfEntry} />
      <Route path="/worktime/attend/team-member-time-qry" component={TeamMemberTimeQry} />
      <Route path="/worktime/attend/individual-schedule-entity" component={IndividualScheduleEntity} />
      <Route path="/worktime/attend/employee-att-setting-qry" component={EmployeeAttSettingQry} />
      <Route path="/worktime/attend/team-member-att-setting-qry" component={TeamMemberAttSettingQry} />
      <Route path="/worktime/attend/sum-attendance-self-entry" component={SumAttendanceSelfEntry} />
      <Route path="/worktime/attend/sum-attendance-team-entry" component={SumAttendanceTeamEntry} />
      <Route path="/worktime/attend/attendance-self-apply" component={AttendanceSelfApply} />
      <Route path="/worktime/attend/att-selective-vacation-mgt" component={AttSelectiveVacationMgt}/>
      <Route path="/worktime/attend/att-selective-vacation-qry" component={AttSelectiveVacationQry}/>
      
    </Switch>
  )
}

function ApprovalDocumentRoutes() {
  return (
    <Switch>
      <Route path="/document/user/approval-document-qry" component={ApprovalDocumentQry} />
    </Switch>
  )
}

function VacationRoutes() {
  return (
    <Switch>
      <Route path="/vacation/list" component={VacationListPage} />
      <Route path="/vacation/request-list" component={VacationRequestListPage} />
      <Route path="/vacation/write" component={VacationWritePage} />
      <Route path="/vacation/admin-list" component={VacationAdminListPage} />
    </Switch>
  )
}

function PayrollRoutes() {
  return (
    <Switch>
      <Route path="/payroll/salary/indv-pay-deduct-qry" component={IndvPayDeductQryPage} />
      <Route path="/payroll/salary/install-payment-application" component={InstallPaymentApplication} />
    </Switch>
  )
}

function AppRouter() {
  return (
    <Router basename="/mobile">
      <Switch>
        <Route path="/" exact component={IndexPage} />
        <Route path="/index.html" exact component={IndexPage} />
        <Route path="/menu/:menuKey" component={MenuPage} />
        <Route path="/worktime" component={WorkTimeRoutes} />
        <Route path="/vacation" component={VacationRoutes} />
        <Route path="/payroll" component={PayrollRoutes} />
        <Route path="/document" component={ApprovalDocumentRoutes} />
        <Route path="/yearend" component={YearendRoutes} />
        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  )
}

/**
 * 로그인 유저 정보 조회
 */
function useFetchMyInfo() {
  const init = useMemo(() => ({method: 'POST'}), [])
  return useFetch(`/att/time-attend/my/info`, init)
}

function Err({error}) {
  console.error({error})
  return <h2>Error</h2>
}

/**
 * DatePicker에 대한 전역포멧 설정
 */
class LocalizedUtils extends DateFnsUtils {
  dateFormat = 'yyyy. MM. dd'
  getDatePickerHeaderText(date) {
    return format(date, 'MMM dd일', {locale: this.locale})
  }
}

const theme = createMuiTheme({
  overrides: {
    MuiButton: {
      sizeSmall: {
        padding: '1px 6px',
      },
    },
  },
  palette: {
    secondary: {
      light: red.A200,
      main: '#cc0010',
      dark: red.A700,
    },
  },
})

function App() {
  const {loading, error, data} = useFetchMyInfo()
  if (error) return <Err error={error} />
  if (loading) return <LoadingLayout />
  if (!data) return <div>No result</div>

  const dat = {
    type: 'person',
    data: {
      gender: 'male',
      info: {
        id: 22,
        fullname: {
          first: 'Dan',
          last: 'Deacon',
        },
      },
    },
  }

  const deepPick = (fields, obj) => {
    const [first, ...remaing] = fields.split('.')
    return remaing.length ? deepPick(remaing.join('.'), obj[first]) : obj[first]
  }

  console.log(deepPick('data.info.fullname.last', dat))

  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={LocalizedUtils} locale={koLocale}>
        <Suspense fallback={<LoadingLayout />}>
          <UserContext.Provider value={data}>
            <MenuProvider>
              <AppRouter />
            </MenuProvider>
          </UserContext.Provider>
        </Suspense>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}

export default App
